import React from 'react'
import styled from 'styled-components'
import { Spin } from 'antd'

const Container = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  height: 250px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: #383e48;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0;
  }

  .sleep-summary {
    .summary-content {
      color: #6d7d8c;
      line-height: 1.6;
    }

    .summary-bullets {
      margin-top: 12px;
      padding-left: 20px;

      li {
        margin-bottom: 8px;
        color: #6d7d8c;
        font-size: 14px;
      }
    }

    .insight-section {
      h4 {
        margin-bottom: 8px;
        color: #383e48;
        font-size: 14px;
        font-weight: 600;
      }

      p {
        margin-bottom: 16px;
        font-size: 14px;
      }
    }

    .divider {
      height: 1px;
      background: #e4e7eb;
      margin: 20px 0;
    }
  }

  .no-data {
    text-align: center;
    color: #9aa5b1;
    padding: 82px 0;
    font-style: italic;
  }

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd2d9;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #9aa5b1;
  }
`

const ClientInsights = ({ sleepSummary, loading }) => {
  const renderSleepSummary = () => {
    if (loading) {
      return (
        <div className="loading-container">
          <Spin size="small" />
        </div>
      )
    }

    if (!sleepSummary || Object.keys(sleepSummary).length === 0) {
      return <div className="no-data">No summary available</div>
    }

    const summaryData = sleepSummary.overall_summary || sleepSummary

    return (
      <div className="sleep-summary">
        <div className="summary-content">
          <ul className="summary-bullets">
            {summaryData.whats_working_well && (
              <li className="insight-section">
                {summaryData.whats_working_well}
              </li>
            )}

            {summaryData.areas_for_attention && (
              <li className="insight-section">
                {summaryData.areas_for_attention}
              </li>
            )}

            {summaryData.action_plan && (
              <li className="insight-section">
                {summaryData.action_plan}
              </li>
            )}
          </ul>
        </div>
      </div>
    )
  }

  return (
    <Container>
      <div className="section-title">Insights Summary</div>
      {renderSleepSummary()}
    </Container>
  )
}

export default ClientInsights
